import React from 'react'
import { HStack } from '@chakra-ui/react'
import { Definition } from '@/components/Card/Definition'
import { ShareContainer } from '@/components/ShareContainer'
import { AnimatePresence, motion } from 'framer-motion'

export const WordFieldBox = ({
  slug,
  name,
  shortDescription,
  selectedWord,
  setSelectedWord,
}: {
  slug: string
  name: string
  shortDescription?: string
  selectedWord: string
  setSelectedWord: (val: string) => void
}) => {
  return (
    <HStack
      alignItems={'flex-start'}
      width={'100%'}
      border={'1px solid #EAEEF4'}
      borderRadius={'12px'}
      gap="0px"
      boxShadow={
        selectedWord === name ? '-4px 16px 40px rgba(0, 0, 0, 0.1)' : 'unset'
      }
      transition={'box-shadow 0.3s ease-in-out'}
      background={'#FFFFFF'}
      px={16}
      py={12}
      onMouseOver={() => setSelectedWord(name)}
      onMouseOut={() => setSelectedWord('')}
    >
      <AnimatePresence>
        {selectedWord === name && (
          <motion.div
            initial={{ width: 0, opacity: 0, marginRight: 0 }}
            animate={{ width: 'auto', opacity: 1, marginRight: '8px' }}
            exit={{ opacity: 0, width: 0, marginRight: 0 }}
          >
            <ShareContainer slug={slug} />
          </motion.div>
        )}
      </AnimatePresence>
      <Definition
        slug={slug}
        name={name}
        shortDescription={shortDescription}
        selectedWord={selectedWord}
        isMobile={false}
      />
    </HStack>
  )
}
